import React from 'react';

class ValidationSuccess extends React.Component {

	getMessage = () => {
		if (this.props.message === undefined || this.props.message === null)
			return "";
		else
			return this.props.message;
	}

	render() {
		return (
			<React.Fragment>
				{this.getMessage() !== "" &&
					<div className="alert alert-success">
						{this.getMessage()}
					</div>
				}
			</React.Fragment>
		)
	}
}

export default ValidationSuccess;



// WEBPACK FOOTER //
// ./src/fw/components/validationSuccess/ValidationSuccess.js